<template>
  <div :class="$pgCTStyle.container">
    <div :class="$pgCTStyle.headerContainer">
      <!-- <div :class="showAllGroupsCTA ? $style.titleEmptyContainer2 : $style.titleEmptyContainer1"></div> -->
      <div :class="$pgCTStyle.title">{{ computedTitle }}</div>
      <div :class="$pgCTStyle.headerRightCTAs">
        <PGHeaderActionButton
          v-if="showAllGroupsCTA"
          :text="$t('all-groups')"
          :clickFunction="openAllGroupsGameTextsVotes"
          backBg="#000000"
          frontBg="#676767"
          textColor="#ffc642"
          :button-width="isMobile ? '70px' : isTablet ? '72px' : '86px'"
        />
        <div v-if="!isGroupComponent" :title="$t('view-info')" :class="$pgCTStyle.actionIconContainer" @click="openModal">
          <img :class="$pgCTStyle.actionIcon" :src="infoIcon" alt="info" />
        </div>
      </div>
    </div>
    <div :class="$pgCTStyle.bodyContainer">
      <div :class="$style.textContainer" v-for="text in textVotes" :key="text.id">
        <div :class="$style.textTopContainer">
          <div :class="$style.textTopLeftContainer">
            <div
              v-if="showVoteButton"
              :class="[$style.voteContainer, player && player.votedTextId == text.id ? $style.voted : '']"
              @click="handleUpdateTextVote(text.id)"
            >
              <div :class="$style.voteCheckbox">
                <img :src="voteTickIcon" alt="vote icon" :class="$style.voteTickIcon" />
              </div>
              <div :class="$style.voteText">
                {{ player && player.votedTextId == text.id ? $t('voted') : $t('vote') }}
              </div>
            </div>
            <div :class="$style.textLabel">{{ $t('text') }} {{ text.label }}</div>
            <!-- <div
              v-if="realTextId && parseInt(realTextId) == text.id"
              :class="$style.correctTextChip"
            >
              {{ $t('correct-text') }}
            </div> -->
          </div>
          <div :class="$style.textTopRightContainer">
            <div :class="$style.textVotes">{{ text.votes ?? 0 }} votes</div>
            <div
              :class="[$style.dropDownIconContainer, text.votes ? '' : $style.noVotesDropDown]"
              @click="text.votes ? toggleExpandText(text.id) : ''"
            >
              <img
                :src="dropDownIcon"
                alt="icon"
                :class="[$style.dropDownIcon, expandStates[text.id] ? $style.iconRotated : '']"
              />
            </div>
          </div>
        </div>
        <transition @enter="enter" @leave="leave">
          <div v-if="expandStates[text.id]" :class="$style.textBottomContainer">
            <div :class="$style.player" v-for="voter in (text.voters ?? [])" :key="voter.id">
              <div :class="$style.avatarBox">
                <img :src="voter.avatar || defaultAvatar" alt="Avatar" :class="$style.avatar" />
              </div>
              <div :class="$style.name">{{ voter.username }}</div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <!-- Modals -->
    <div v-if="showInfoModal" :class="$utilModalStyle.modalOverlay" @click="closeModal">
      <div :class="[$utilModalStyle.modalContent]" @click.stop>
        <h3 :class="$utilModalStyle.modalTitle">{{ $t('text-votes-info-modal-title') }}</h3>
        <div :class="$utilModalStyle.modalBody">
          <div :class="$style.modalTextItem">
            {{ $t('vote-description') }}
          </div>
        </div>
        <div :class="$utilModalStyle.modalActions">
          <button :class="$utilModalStyle.primaryAction" @click="closeModal">{{ $t('close') }}</button>
        </div>
      </div>
    </div>

    <!-- <div v-if="showConsensusModal && isHost" :class="$globalStyle.modalOverlay" @click="showConsensusModal = false">
      <div :class="$globalStyle.modalContent" @click.stop>
        <div :class="$style.modalPrimaryText">Players have reached a consensus!</div>
        <div :class="$style.modalSecondaryText">Would you like to proceed to the next phase?</div>
        <div :class="$globalStyle.modalActions">
          <button :class="$globalStyle.secondaryAction" @click="closeConsensusModal">I'll Wait</button>
          <button :class="$globalStyle.primaryAction" @click="handleProceed">Proceed</button>
        </div>
        <div :class="$globalStyle.modalHelperText">
          <span>Note:</span> If the timer runs out, the game will automatically proceed to the next phase!
        </div>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, reactive, computed } from "vue";
import { useI18n } from "vue-i18n";
import styles from "@/css/GameTextsVoteBox.module.css";
import utilModalStyles from "@/css/UtilModal.module.css";
import playGameComponentsTemplateStyles from "@/css/PlayGameComponentsTemplate.module.css";
import PGHeaderActionButton from "../buttons/PGHeaderActionButton.vue";
// import globalStyles from "@/css/global.module.css";
import InfoIcon from "@/assets/icons/info.svg";
import DropDownIcon from "@/assets/icons/down-black.svg";
import VoteTickIcon from "@/assets/icons/checkbox-yellow.svg";
import { defaultAvatar } from "@/utils/data";
// import UtilButton from "../util/UtilButton.vue";
import { NOOP } from "@/utils/functions";
import useDeviceType from "@/utils/useDeviceType";

const device = useDeviceType();

// const width = device.width.value;
// const height = device.height.value;
const isMobile = device.isMobile.value;
const isTablet = device.isTablet.value;
// const isDesktop = device.isDesktop.value;

const $style = styles;
const $utilModalStyle = utilModalStyles;
const $pgCTStyle = playGameComponentsTemplateStyles;
const infoIcon = InfoIcon;
const dropDownIcon = DropDownIcon;
const voteTickIcon = VoteTickIcon;

const showInfoModal = ref(false);
const { t: translate } = useI18n();
// const showConsensusModal = ref(false);
// const userTextVoteId = ref(null);
// const textVotesData = ref([]);

const expandStates = reactive({});
// const textVotesData = reactive([]);

const showAllGroupsCTA = computed(() => {
  return props.openAllGroupsGameTextsVotes !== NOOP && props.canOpenAllGroups;
});

const computedTitle = computed(() => {
  return props.title || translate("text-votes");
});

const showVoteButton = computed(() => {
  return props.updateTextVote !== NOOP && !props.isHost;
});



// eslint-disable-next-line
const props = defineProps({
  canOpenAllGroups: {
  type: Boolean,
  required: false,
  default: false,
},
  players: {
    type: Array,
    required: true,
  },
  // texts: {
  //   type: Array,
  //   required: true,
  // },
  textVotes: {
    type: Array,
    required: false,
    default: () => [],
  },
  isHost: {
    type: Boolean,
    required: true,
  },
  user: {
    type: Object,
    required: true,
  },
  updateTextVote: {
    type: Function,
    required: false,
    default: NOOP,
  },
  // proceedNext: {
  //   type: Function,
  //   required: true,
  // },
  openAllGroupsGameTextsVotes: {
    type: Function,
    required: false,
    default: NOOP,
  },
  isGroupComponent: {
    type: Boolean,
    required: false,
    default: false,
  },
  title: {
    type: String,
    required: false,
    default: "",
  },
  player: {
    type: Object,
    required: false,
    default: () => {},
  },
});

function enter(el, done) {
  //   console.log("enter", el);
  done();
}

function leave(el, done) {
  //   console.log("leave", el);
  done();
}

function openModal() {
  // Implement modal opening logic here
  // console.log("Open modal with game texts information");
  showInfoModal.value = true;
}

function closeModal() {
  // Implement modal closing logic here
  // console.log("Close modal with game texts information");
  showInfoModal.value = false;
}

function toggleExpandText(textId) {
  expandStates[textId] = !expandStates[textId];
}

async function handleUpdateTextVote(textId) {
  // console.log("Update text vote for text ID:", textId);
  //   props.updateTextVote(textId);

  if (props.player && props.player.votedTextId == textId) {
    // console.log("Already voted for this text");
    return;
  }

  try {
    await props.updateTextVote(textId);
  } catch (error) {
    console.error("Failed to update text vote:", error);
  } finally {
    // any common closing logic can go here
  }
}

// function closeConsensusModal() {
//   showConsensusModal.value = false;
// }

// function handleProceed() {
//   console.log("Proceed to the next phase");
//   showConsensusModal.value = false;
//   props.proceedNext();
// }

// const userTextVoteId = computed(() => {
//   const me = props.players.find((p) => p.id === props.user.id);
//   return me?.voted_text_id || null;
// });

// const textVotesData = computed(() =>
//   props.texts.map((text) => {
//     console.log("Processing text:", text);

//     const voters = props.players.filter(
//       (player) => player.voted_text_id && player.voted_text_id === text.id
//     );

//     return {
//       ...text,
//       voters: voters,
//       votes: voters.length,
//     };
//   })
// );

// watchEffect(() => {
//   console.log("✅ watchEffect triggered due to props.players or props.texts change");

//   const me = props.players.find((p) => p.id === props.user.id);
//   console.log("👤 Current user:", props.user);
//   console.log("🧑‍🤝‍🧑 All players:", props.players);
//   console.log("🔍 Found my player object:", me);

//   userTextVoteId.value = me?.votedTextId || null;
//   console.log("🗳️ userTextVoteId set to:", userTextVoteId.value);

//   textVotesData.value = props.texts.map((text) => {
//     const voters = props.players.filter((player) => player.votedTextId && player.votedTextId === text.id);

//     console.log(`📄 Text ID ${text.id} - Label ${text.label} has ${voters.length} votes`);
//     return {
//       ...text,
//       voters,
//       votes: voters.length,
//     };
//   });

//   console.log("📊 Final textVotesData:", textVotesData.value);
// });

onMounted(() => {
  // console.log("Mounted");
  props.textVotes.forEach((text) => {
    expandStates[text.id] = false;
  });
});

onBeforeUnmount(() => {
  // console.log("Before unmount");
});

// if (props.isHost) {
//   watch(
//     () => props.textVotes, // source
//     (newTextVotes) => {
//       console.log("Watching Text Votes updated:", newTextVotes);
//       const voteMap = {};

//       newTextVotes.forEach((textVote) => {
//         const textId = textVote.textId;
//         const voteCount = textVote.voteCount || 0;
//         if (textId) {
//           voteMap[textId] = voteCount;
//         }
//       });

//       const totalPlayers = props.players.length;
//       const nMinusOne = totalPlayers - 1;

//       const anyTextWithEnoughVotes = Object.values(voteMap).some((voteCount) => voteCount >= nMinusOne);

//       showConsensusModal.value = anyTextWithEnoughVotes;
//     },
//     { deep: true } // important for arrays of objects
//   )
// }
</script>

<style scoped></style>
